var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 13C20.6087 12.5105 20.5652 12.022 20.48 11.54L23.22 9.24L20.92 5.24L17.56 6.48C16.809 5.84355 15.9528 5.34274 15.03 5L14.41 1.5H9.81L9.19 5C8.26715 5.34274 7.41103 5.84355 6.66 6.48L3.3 5.26L1 9.26L3.74 11.56C3.56086 12.5251 3.56086 13.5149 3.74 14.48L1 16.76L3.3 20.76L6.66 19.53C7.4119 20.1627 8.26795 20.6601 9.19 21L9.81 24.5H14.41L15.03 21C15.9549 20.6642 16.8143 20.1702 17.57 19.54L20.93 20.77L23.23 16.77L20.49 14.47C20.5724 13.9844 20.6126 13.4925 20.61 13V13Z",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1099 17.5C14.5951 17.5 16.6099 15.4853 16.6099 13C16.6099 10.5147 14.5951 8.5 12.1099 8.5C9.62458 8.5 7.60986 10.5147 7.60986 13C7.60986 15.4853 9.62458 17.5 12.1099 17.5Z",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cdba1136dd7b840f068ba8653c82b291.svg";
export { ForwardRef as ReactComponent };